import React, { useEffect, useState, useRef } from 'react';
import Header from 'components/Headers/Header';
import { Button, Card, CardBody, CardHeader, Col, Container, FormGroup, Input, Row, Spinner } from 'reactstrap';
import moment from 'moment';
import { useForm } from 'react-hook-form';
import Select from 'react-select';
import { CSVLink } from "react-csv";

//Services
import { api_GET, api_POST } from '../../../../services/api_service';
import { showMessage } from '../../../../services/message';
import { getSessionCookie } from '../../../../services/session';

//CSS
import "../../../../assets/css/loading.css";
import { formateDateApi } from 'helpers/formats';

//Components
import RelatorioOcorrencia from './RelatorioOcorrencia';

function initialStateCabecalho() {
  return {
    modalidade: "",
    dataInicio: "",
    dataFim: "",
  }
}
function Ocorrencias({ history }) {
  const { register, errors, setValue, clearErrors } = useForm({ mode: "onBlur" });

  const [showLoading, setshowLoading] = useState(false);

  const session = getSessionCookie();

  const exportRef = useRef(null);

  const [inicio, setInicio] = useState(formateDateApi(moment().subtract(1, 'month')));
  const [fim, setFim] = useState(formateDateApi(moment(new Date())));

  //State para pegar dados para cabeçalho
  const [cabecalho, setCabecalho] = useState(initialStateCabecalho());

  const headersExport = [
    { label: 'MODALIDADE', key: 'modalidade' },
    { label: 'DIVISÃO ADMINISTRATIVA', key: 'divisaoAdministrativa' },
    { label: 'PLANO DE TRABALHO', key: 'planoTrabalho' },
    { label: 'OPERADOR', key: 'operador' },
    { label: 'RECURSO', key: 'veiculo' },
    { label: 'DATA/HORA - INÍCIO DA EXECUÇÃO', key: 'dataHoraExecucaoInicio' },
    { label: 'DATA/HORA - FIM DA EXECUÇÃO', key: 'dataHoraExecucaoFim' },
    { label: 'DATA/HORA DA OCORRÊNCIA', key: 'dataHoraJustificativaOcorrencia' },
    { label: 'JUSTIFICATIVA DA OCORRÊNCIA', key: 'justificativaOcorrencia' },
    { label: 'DESCRIÇÃO DA OCORRÊNCIA', key: 'descricaoOcorrencia' },
    { label: 'USUÁRIO RESPONSÁVEL PELO REGISTRO DA  OCORRÊNCIA', key: 'usuarioDenunciante' },
  ]
  const [csvData, set_csvData] = useState([]);

  // Modalidade
  const [optionsModalidadesColeta, setoptionsModalidadesColeta] = useState([]);
  const [modalidadesColeta, setModalidadesColeta] = useState({ descricao: "Todas", modalidadeColetaId: null });
  const loadOptionsModalidadesColeta = () => {
    api_GET(`modalidadeColeta`).then(result => {
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        setoptionsModalidadesColeta([{ descricao: "Todas", modalidadeColetaId: null }, ...result.data]);
      }
    });
  }

  const [optionsConcessionaria, setOptionsConcessionaria] = useState([])
  const [concessionaria, setConcessionaria] = useState({ identificacao: "Todas", concessionariaId: null });
  const loadConcessionarias = () => {
    api_GET(`Concessionaria`).then(result => {
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        setOptionsConcessionaria([{ identificacao: "Todas", concessionariaId: null }, ...result.data]);
      }
    });
  }

  useEffect(() => {
    loadOptionsModalidadesColeta();
    loadConcessionarias();

    if (session != null && session.perfil == "Adm")
      setConcessionaria({ concessionariaId: session.concessionariaId })
  }, []);

  const handleModalidadesColeta = (value) => {
    setModalidadesColeta(value);
  }

  const handleConcessioria = (value) => {
    setConcessionaria(value)
  }

  const [relatorioOcorrencia, setRelatorioOcorrencia] = useState(null);
  const handleGerarRelatorio = (gerarExcel = false) => {
    if (modalidadesColeta == null) {
      showMessage("Aviso", "Por favor, Selecione a modalidade de coleta.", "warning", null);
      return;
    }

    const json = {
      modalidadeColetaId: modalidadesColeta.modalidadeColetaId,
      dataInicio: inicio,
      dataFim: fim,
      concessionariaId: concessionaria.concessionariaId
    }

    setCabecalho({
      dataFim: fim,
      dataInicio: inicio,
      modalidade: modalidadesColeta.descricao,
    })

    setshowLoading(true);
    api_POST("Relatorio/RelatorioOcorrencia", json).then(result => {
      setshowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
        return;
      }
      else {
        if (!gerarExcel)
          setRelatorioOcorrencia(result.data);
        else {
          set_csvData(result.data);
          if (exportRef.current)
            exportRef.current.link.click();
        }
      }
    });
  }

  const handleGerarExcel = () => {
    handleGerarRelatorio(true);
  }

  const handleReturn = () => {
    setRelatorioOcorrencia(null);
    setModalidadesColeta(null);
    setInicio(formateDateApi(moment().subtract(1, 'month')));
    setFim(formateDateApi(moment(new Date())));
    setCabecalho(initialStateCabecalho())
  }

  return <>
    {showLoading &&
      <div className="carregandoCmp">
        <div className="box">
          <label style={{ marginRight: "20px" }}>Carregando...</label>
          <Spinner size="sm" color="info" />
        </div>
      </div>
    }
    {!relatorioOcorrencia &&
      <>
        <Header />
        <Container className="mt--9" fluid>
          <Row>
            <Container className="mt-1" fluid>
              <div className='d-flex justify-content-between align-items-center mb-1'>
                <Button color="secondary" type="button" onClick={() => history.goBack()}>
                  Voltar
                </Button>
              </div>
              <Card className="shadow">
                <CardBody>
                  <div className='d-flex justify-content-end items-align-center mb-1'>
                    <span className='text-danger'>* Campos Obrigatórios</span>
                  </div>
                  <Row>
                    <Col md="4" lg="3">
                      <FormGroup >
                        <label className="form-control-label">
                          Concessionarias
                        </label>
                        <Select
                          options={optionsConcessionaria}
                          getOptionLabel={({ identificacao }) => identificacao}
                          getOptionValue={({ concessionariaId }) => concessionariaId}
                          onChange={(value) => { handleConcessioria(value) }}
                          isDisabled={session.perfil == "Adm"}
                          value={optionsConcessionaria.find(x => x.concessionariaId == concessionaria.concessionariaId)}
                          placeholder="Selecione"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12" lg="2">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input-address" >
                          * Data Início
                        </label>
                        <Input
                          className="form-control-alternative"
                          innerRef={register({ required: true })}
                          defaultValue={inicio ? formateDateApi(inicio) : ""}
                          name="dataInicio"
                          placeholder="Data Início"
                          type="date"
                          max={formateDateApi(moment(new Date()))}
                          onBlur={(e) => setInicio(formateDateApi(e.target.value))}
                        />
                        {errors.dataInicio && <span className="form-control-label">* Campo Obrigatório</span>}
                      </FormGroup>
                    </Col>
                    <Col md="12" lg="2">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input-address" >
                          * Data Fim
                        </label>
                        <Input
                          className="form-control-alternative"
                          innerRef={register({ required: true })}
                          defaultValue={fim ? formateDateApi(fim) : ""}
                          name="dataFim"
                          placeholder="Data Fim"
                          type="date"
                          max={formateDateApi(moment(new Date()))}
                          onBlur={(e) => setFim(formateDateApi(e.target.value))}
                        />
                        {errors.dataFim && <span className="form-control-label">* Campo Obrigatório</span>}
                      </FormGroup>
                    </Col>
                    <Col md="4" lg="5">
                      <FormGroup >
                        <label className="form-control-label">
                          * Modalidades de Serviço
                        </label>
                        <Select
                          options={optionsModalidadesColeta}
                          getOptionLabel={({ descricao }) => descricao}
                          getOptionValue={({ modalidadeColetaId }) => modalidadeColetaId}
                          onChange={(value) => { handleModalidadesColeta(value) }}
                          value={modalidadesColeta ? optionsModalidadesColeta.filter(x => x.modalidadeColetaId == modalidadesColeta.modalidadeColetaId)[0] : null}
                          placeholder="Selecione"
                        />
                      </FormGroup>
                    </Col>
                    <Col className="text-center" lg="12">
                      <Button
                        color="danger"
                        type="button"
                        onClick={() => handleGerarRelatorio()}>
                        GERAR PDF
                      </Button>
                      <Button
                        color="success"
                        type="button"
                        onClick={handleGerarExcel}>
                        GERAR CSV
                      </Button>
                      {csvData.length > 0 &&
                        <CSVLink
                          data={csvData}
                          headers={headersExport}
                          filename="RelatorioOcorrencia.csv"
                          target="_blank"
                          separator={";"}
                          ref={exportRef}
                        >
                        </CSVLink>
                      }
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Container>
          </Row>
        </Container>
      </>
    }

    {relatorioOcorrencia &&
      <RelatorioOcorrencia
        cabecalho={cabecalho}
        handleReturn={handleReturn}
        relatorio={relatorioOcorrencia}
      />
    }
  </>;
}

export default Ocorrencias;